import React, {Component} from 'react'

class PlayerYouku {
    constructor(id, container) {

        this.id = this._parseID(id);
        this.container = container;
    }

    get imageURL() {
        return Promise.resolve('')
    }

    play() {
        this.container.innerHTML = '<iframe height="498" width="510" src="https://player.youku.com/embed/'+ this.id +'?autoplay=1" frameborder="0" allowfullscreen></iframe>'
    }

    stop() {
        if (this.player)
            this.player.pause();
    }

    set onPlayCallback(fn) {
        if (typeof fn === "function")
            this._onPlay = fn;
    }

    _onPlay() {

    }

    //
    // UTILS
    //
    _parseID(id) {
        if (id.indexOf('/') === -1)
            return id;

        let exp = new RegExp('(?:embed/|v_show/id_)([^"\'&?/. ]*)', 'i')
        let match = id.match(exp);
        if (match) {
            return match[1];
        }
        return id;
    }
}

export default (PlayerYouku)



// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/players/PlayerYouku.js